module.exports = __webpack_public_path__ + "img/card.d14056ce.svg";